import styled from 'styled-components';
import { Paragraph } from '@increasecard/typed-components';

export const SuccessMessage = styled(Paragraph)`
  color: ${({ theme }) => theme.colorsNew.increase.regular};
`;

export const SuccessMessageContainer = styled.div`
  height: 40px;
`;
